import React from 'react';
import autoBind from 'react-autobind';
import Formatter from '../utils/Formatter';
import AnnnuitiesWelcomePageStore from '../stores/AnnuitiesWelcomePageStore';
import ContentService from '../services/ContentService';
import SlidingSessionNotification from './SlidingSessionNotification.jsx';

export default class AnnuitiesWelcomePage extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.Content = ContentService.getContent();
        this.state = this.getStateFromStore();
    }

    getStateFromStore(){
        return {
            data: AnnnuitiesWelcomePageStore.getData()
        }
    }

    componentDidMount() {
        AnnnuitiesWelcomePageStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        AnnnuitiesWelcomePageStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(this.getStateFromStore());
    }

    render() {
        return (
            <div className="container">
                <SlidingSessionNotification />
                <div className="investor-welcome-container">
                    <p dangerouslySetInnerHTML={{__html: Formatter.formatString(this.Content.annuitiesWelcomePage.productAccountSetupCopy, {productName: this.state.data.productName, investorName: this.state.data.name})}}></p>
                    <h5>{this.Content.annuitiesWelcomePage.accountNumberLabel}: {this.state.data.accountNumber}</h5>
                </div>
                <div className="next-step-container" dangerouslySetInnerHTML={{__html: this.Content.annuitiesWelcomePage.oneLastStepCopy}}></div>
            </div>);
    }
}



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/AnnuitiesWelcomePage.jsx